import useStyles from "./VehicleNewsListPage/styles"
import Thumbnail from "../Thumbnail"
import { Box, Typography } from "@material-ui/core"
import React from "react"

function NewsItem({
    news, url, alt, ...props
}) {
    const classes = useStyles()

    return (
        <Box {...props}>
            <Typography
                variant="h6"
                className={classes.publishedText}
            >
                {new Date(news.dateTime).toLocaleDateString()}
            </Typography>
            <Thumbnail
                href={url}
                src={news.images?.[0]}
                alt={alt}
                className={classes.itemThumbnail}
                width="100%"
                srcWidth="1500"
            />
        </Box>
    )
}
export default NewsItem
